import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  ECampaignKeys,
  TCampaign,
  TCampaignUpdatePayload,
  TCampaignError,
} from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

const updateCampaign = (id: string, payload: TCampaignUpdatePayload) => {
  return HttpService.put<TCampaign | TCampaignError>(
    {
      path: pathBuilder(EServerPath.campaign, { id }),
      payload,
    },
    EHttpService.internal,
  ).then((res) => {
    return res.data ? res.data : res
  })
}

const useUpdateCampaign = (id: string) => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (payload: TCampaignUpdatePayload) =>
      updateCampaign(id, payload),
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.campaign(id),
      })
      if (
        ECampaignKeys.ofuIsManual in payload &&
        payload[ECampaignKeys.ofuIsManual] !== undefined
      ) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.campaignContactsPaginated(id, 100),
          exact: false,
        })
      }
    },
  })

  return {
    ...mutation,
  }
}

export default useUpdateCampaign
